"use client";
import { useEffect, useState } from "react";
import { RiArrowUpLine } from "react-icons/ri";
import "./ProgressButton.css";

const ProgressButton = () => {
  const [progress, setProgress] = useState(0);
  const [stroke, setStroke] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const body = document.body;
      const html = document.documentElement;

      const totalHeight = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
      );

      setProgress(totalHeight);

      const currentDistance = window.scrollY / (totalHeight / 3000);
      setStroke(totalHeight - currentDistance / 8);

      if (window.scrollY === 0) {
        setStroke(totalHeight);
      }

      if (window.innerHeight + window.scrollY >= totalHeight) {
        setStroke(0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // initial call

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      onClick={scrollToTop}
      className={`progress-wrap ${stroke < progress ? "active-progress" : ""}`}
    >
      {/* آیکن */}
      <RiArrowUpLine size={25} className="progress-icon" />

      {/* SVG */}
      <svg
        className="progress-circle svg-content"
        width="100%"
        height="100%"
        viewBox="-1 -1 102 102"
      >
        <path
          d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          style={{
            transition: "stroke-dashoffset 10ms linear",
            strokeDasharray: `${progress}px, ${progress}px`,
            strokeDashoffset: `${stroke}px`,
          }}
        />
      </svg>
    </div>
  );
};

export default ProgressButton;
